import React from 'react';
import CustomersContainer from 'containers/CustomerTable';

const CustomerTable = () => {
  return  (
    <>
     <CustomersContainer />
    </>
  );
};

export default CustomerTable;
